import React from "react";
import greyBubbles from "../img/graytopcirclesPC.png";
import { motion, Variants } from "framer-motion";
import {
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBInputGroup,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";
import icon1 from "../../src/img/menu_book.png";
import icon2 from "../../src/img/psychology.png";
import icon3 from "../../src/img/directions_walk.png";
import arrow from "../../src/img/Arrow42.png";

export const PelvicProgramBanner4 = ({ width }) => {
  const cardVariants1 = {
    offscreen: {
      x: 0,
      opacity: 0,
    },
    onscreen: {
      transition: {
        type: "spring",
        bounce: 0.1,
        duration: 1,
      },
      opacity: 1,
    },
  };
  const cardVariants2 = {
    offscreen: {
      x: 0,
      opacity: 0,
    },
    onscreen: {
      // x: "160%",
      transition: {
        type: "spring",
        bounce: 0.2,
        duration: 4,
      },
      opacity: 1,
    },
  };
  const cardVariants3 = {
    offscreen: {
      x: 0,
      opacity: 0,
    },
    onscreen: {
      // x:'270%',
      transition: {
        type: "spring",
        bounce: 0.2,
        duration: 6,
      },
      opacity: 1,
    },
  };

  // small screen pc

  const cardVariantsMedium1 = {
    offscreen: {
      x: 0,
      opacity: 0,
    },
    onscreen: {
      x: "20%",
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 1,
      },
      opacity: 1,
    },
  };
  const cardVariantsMedium2 = {
    offscreen: {
      x: 0,
      opacity: 0,
    },
    onscreen: {
      x: "105%",
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 2,
      },
      opacity: 1,
    },
  };
  const cardVariantsMedium3 = {
    offscreen: {
      x: -20,
      opacity: 0,
    },
    onscreen: {
      x: "190%",
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 3,
      },
      opacity: 1,
    },
  };

  return (
    <div className="pelvic-program-banner-4">
      <div className="text-center pt-3">
        <h3 className="text-al fs-48-28 pt-4">How Does it Work?</h3>
        <p className="text-dm m-0 fs-24-16">
          In just <strong className="text-al fs-32-24-20">20 minutes a day</strong><br className="no-pc"/> about
          <strong className="text-al fs-32-24-20"> 3x per week</strong>
        </p>
        <p className="text-dm m-0 fs-24-16">
          you’ll start noticing positive changes<br className="no-pc"/> in about 3 months.
        </p>
      </div>
      <div className="mt-5 text-center">
        <span className={width > 840 ? "text-al fs-32-20 color-change-mobile" : "text-dm fs-20 color-change-mobile"}>
          <strong className="no-ipad">3 Step Restorative Online Program</strong>
          <p className="no-pc-new">3 Step Restorative Online Program</p>
        </span>
      </div>
      <div className={width < 600 ? "display-animation-in-pc d-flex justify-content-evenly" : "display-animation-in-pc d-flex justify-content-evenly mt-5 pt-2"}>
        <motion.div
          variants={cardVariants1}
          initial="offscreen"
          whileInView="onscreen"
          className="no-mobile"
        >
          <div className="d-flex justify-content-center">
            <div className="d-flex justify-content-center">
              <div className="box-pelvic-program-white text-dm">
                <div>
                  <p className="text-center mt-3 cards-program text-dm">STEP 1</p>
                  <p className="text-center big-p-program-text fs-24-20 text-dm">LEARN</p>
                </div>
                <div className="d-flex justify-content-center mt-2">
                  <img src={icon1} />
                </div>
                <div className="p-4 text-center">
                  <p>
                    Self-healing techniques and strategies with videos for
                    achieving optimum pelvic function backed by pain
                    neuroscience.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div
        className="no-mobile"
          variants={cardVariants2}
          initial="offscreen"
          whileInView="onscreen"
        >
          <div className="d-flex justify-content-center">
            <div className="d-flex justify-content-center">
              <div className="box-pelvic-program-white text-dm">
                <div>
                  <p className="text-center mt-3 cards-program text-dm">STEP 2</p>
                  <p className="text-center big-p-program-text fs-24-20 text-dm">REWIRE</p>
                </div>
                <div className="d-flex justify-content-center">
                  <img src={icon2} />
                </div>
                <div className="p-4 text-center">
                  <p>
                    Calming techniques for your central nervous system through
                    guided meditations. Help your brain send more feel-good
                    chemicals to your body, and lower pelvic tension.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
        className="no-mobile"
          variants={cardVariants3}
          initial="offscreen"
          whileInView="onscreen"
        >
          <div className="d-flex justify-content-center">
            <div className="d-flex justify-content-center">
              <div className="box-pelvic-program-white text-dm">
                <div>
                  <p className="text-center mt-3 cards-program text-dm text-dm">STEP 3</p>
                  <p className="text-center big-p-program-text text-dm fs-24-20 text-dm">MOVE</p>
                </div>
                <div className="d-flex justify-content-center">
                  <img src={icon3} />
                </div>
                <div className="p-4 text-center">
                  <p className="">
                    Follow a mindful movement video program so your brain “sees”
                    body exercise as safe through breathwork and gentle
                    stretches. Progress to core stabilization exercises.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
      <div className="mt-5 no-pc">
        <MDBRow className="padding-control">
          <MDBCol size="12" md="4" order="1">
            <div className="d-flex justify-content-center">
              <div className="d-flex justify-content-center">
                <div className="box-pelvic-program-white">
                  <div>
                    <p className="text-center mt-3 cards-program text-dm">STEP 1</p>
                    <p className="text-center text-dm fs-24-20">LEARN</p>
                  </div>
                  <div className="d-flex justify-content-center mt-2">
                    <img src={icon1} />
                  </div>
                  <div className="p-4 text-center">
                    <p>
                      Self-healing techniques and strategies with videos for
                      achieving optimum pelvic function backed by pain
                      neuroscience.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </MDBCol>

          <MDBCol size="12" md="4" order="2">
            <div className="d-flex justify-content-center">
              <div className="d-flex justify-content-center">
                <div className="box-pelvic-program-white">
                  <div>
                    <p className="text-center mt-3 cards-program text-dm">STEP 2</p>
                    <p className="text-center text-dm fs-24-20">REWIRE</p>
                  </div>
                  <div className="d-flex justify-content-center">
                    <img src={icon2} />
                  </div>
                  <div className="p-4 text-center">
                    <p>
                      Calming techniques for your central nervous system through
                      guided meditations. Help your brain send more feel-good
                      chemicals to your body, and lower pelvic tension.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </MDBCol>
          <MDBCol size="12" md="4" order="3">
            <div className="d-flex justify-content-center">
              <div className="d-flex justify-content-center">
                <div className="box-pelvic-program-white">
                  <div>
                    <p className="text-center mt-3 cards-program">STEP 3</p>
                    <p className="text-center fs-24-20">MOVE</p>
                  </div>
                  <div className="d-flex justify-content-center">
                    <img src={icon3} />
                  </div>
                  <div className="p-4 text-center">
                    <p className="">
                      Follow a mindful movement video program so your brain
                      “sees” body exercise as safe through breathwork and gentle
                      stretches. Progress to core stabilization exercises.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
      <div className="mt-5 d-flex justify-content-center">
        <div>
          <a href="#selectYourPlan">
          <button className="button-pelvicProgram blue-hover border-0">START A FREE TRIAL</button>
          </a>
        </div>
      </div>
    </div>
  );
};
